var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentMetrics',[[_c('Metric',{attrs:{"value":_vm.summary.waiting,"title":_vm.titles.waiting,"border":true}}),_c('Metric',{attrs:{"value":_vm.summary.exceeded,"title":_vm.titles.exceeded,"border":true}}),_c('Metric',{attrs:{"value":_vm.summary.departed,"title":_vm.titles.departed}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }